import React from "react";
import styled from "@emotion/styled";
import * as Tooltip from "@radix-ui/react-tooltip";

interface TooltipComponentProps {
  children: React.ReactNode;
  content: React.ReactNode;
  delayDuration?: number;
  side?: "top" | "right" | "bottom" | "left";
  variant?: "default" | "dark";
}

function TooltipComponent({
  children,
  content,
  delayDuration = 700,
  side = "top",
  variant = "default",
}: TooltipComponentProps) {
  return (
    <Tooltip.Provider delayDuration={delayDuration}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>{children}</Tooltip.Trigger>
        <Tooltip.Portal>
          <StyledContent sideOffset={5} side={side} variant={variant}>
            {content}
            <StyledArrow variant={variant} />
          </StyledContent>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
}

export default TooltipComponent;

const StyledContent = styled(Tooltip.Content)<{ variant: "default" | "dark" }>(
  ({ theme, variant }) => ({
    zIndex: 9999,
    ...(variant === "default" && {
      backgroundColor: theme.colors.sysBackgroundDefault,
      padding: "16px",
      borderRadius: "8px",
      boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
      maxWidth: "290px",
      whiteSpace: "pre-wrap",
      fontFamily: theme.fontFamily,
      fontSize: "14px",
    }),
    ...(variant === "dark" && {
      display: "flex",
      padding: "12px",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "4px",
      alignSelf: "stretch",
      borderRadius: "4px",
      background: "#2D3B54",
      color: theme.colors.sysTextWhite,
      maxWidth: "290px",
      whiteSpace: "pre-wrap",
      fontFamily: theme.fontFamily,
      fontSize: "14px",
    }),
  }),
);

const StyledArrow = styled(Tooltip.Arrow)<{ variant: "default" | "dark" }>(
  ({ theme, variant }) => ({
    fill: variant === "default" ? theme.colors.sysBackgroundDefault : "#2D3B54",
    width: "28px",
    height: "14px",
  }),
);
